import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconCircleDashed = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M10.1 2.2a10 10 0 0 1 3.8 0M17.6 4.4a10 10 0 0 1 2.7 2.7M21.8 10.1a10 10 0 0 1 0 3.8M19.6 17.6a10 10 0 0 1-2.7 2.7M13.9 21.8a10 10 0 0 1-3.8 0M6.4 19.6a10 10 0 0 1-2.7-2.7M2.2 13.9a10 10 0 0 1 0-3.8M4.4 6.4a10 10 0 0 1 2.7-2.7' />
    </g>
  </SDIcon>
)

export default IconCircleDashed
